import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1397_127569)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.375 5.25H6.125C5.64175 5.25 5.25 5.64175 5.25 6.125V11.375C5.25 11.8582 5.64175 12.25 6.125 12.25H11.375C11.8582 12.25 12.25 11.8582 12.25 11.375V6.125C12.25 5.64175 11.8582 5.25 11.375 5.25Z",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.875 5.25H16.625C16.1418 5.25 15.75 5.64175 15.75 6.125V11.375C15.75 11.8582 16.1418 12.25 16.625 12.25H21.875C22.3582 12.25 22.75 11.8582 22.75 11.375V6.125C22.75 5.64175 22.3582 5.25 21.875 5.25Z",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.375 15.75H6.125C5.64175 15.75 5.25 16.1418 5.25 16.625V21.875C5.25 22.3582 5.64175 22.75 6.125 22.75H11.375C11.8582 22.75 12.25 22.3582 12.25 21.875V16.625C12.25 16.1418 11.8582 15.75 11.375 15.75Z",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.875 15.75H16.625C16.1418 15.75 15.75 16.1418 15.75 16.625V21.875C15.75 22.3582 16.1418 22.75 16.625 22.75H21.875C22.3582 22.75 22.75 22.3582 22.75 21.875V16.625C22.75 16.1418 22.3582 15.75 21.875 15.75Z",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1397_127569",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export { SvgDashboard as ReactComponent };
